// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-subheading[data-v-b4424d08]{font-family:Exo\\ 2,sans-serif;text-align:center;font-size:1.125rem;line-height:1.75rem;font-weight:400;line-height:1.5rem;--tw-text-opacity:1;color:rgba(70,33,74,var(--tw-text-opacity))}@media (min-width:1024px){.p-subheading[data-v-b4424d08]{font-size:1.25rem;line-height:1.75rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
